import script from "./SkipLink.vue?vue&type=script&setup=true&lang=js"
export * from "./SkipLink.vue?vue&type=script&setup=true&lang=js"

import "./SkipLink.vue?vue&type=style&index=0&id=afd2de90&lang=css"

const __exports__ = script;

export default __exports__